import { getAssistantId } from 'chatspot-core/assistants/getAssistantId';

/** We only want to show the Sales Copilot threads in the UI */
const filterSalesCopilotThreads = threads => {
  const assistantId = getAssistantId();
  return threads.filter(thread => thread.assistantId === assistantId);
};
export const formatHubGptThreadsToCopilotThreads = threads => {
  const salesCopilotThreads = filterSalesCopilotThreads(threads);
  const transformCopilotThreads = salesCopilotThreads.map(thread => {
    return {
      createdAt: thread.createdAt,
      isStale: false,
      label: thread.title,
      labelStatus: 'INITIALIZED',
      lastInteractionCreatedAt: thread.createdAt,
      lastInteractionId: thread.id,
      lastInteractionUpdatedAt: thread.updatedAt,
      portalId: null,
      id: thread.id,
      userId: thread.userId,
      assistantType: 'salesCopilot'
    };
  });
  return transformCopilotThreads;
};